import { render, staticRenderFns } from "./MessageItemAttachment.vue?vue&type=template&id=358c29c2&"
import script from "./MessageItemAttachment.vue?vue&type=script&lang=ts&"
export * from "./MessageItemAttachment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports